import { initializeFirestore } from 'firebase/firestore';
import { firebaseApp } from './FirebaseConfig';

// eslint-disable-next-line import/prefer-default-export
export const firestore = initializeFirestore(firebaseApp, { useFetchStreams: false });
